<template>
	<TypographyTitle :level="2">
		{{ $t('payments.header') }}
	</TypographyTitle>
	<Table
		:columns="columns"
		:data-source="payments"
		:pagination="true"
		:bordered="true"
		:loading="isLoading"
		size="small"
	>
		<template #bodyCell="{ column, record }">
			<template v-if="['created_at', 'paid_at'].includes(column.dataIndex)">
				<DatetimeFormatter v-if="record != null" :value="record[column.dataIndex]" defaultValue="" />
			</template>
			<template v-else-if="column.dataIndex === 'status'">
				<Badge class="nobr" :status="record.statusDisplay" :text="$t('payment-page.statusValues.' + record.status)" />
			</template>
			<template v-else-if="column.dataIndex === 'uuid'">
				<router-link :to="{ name: 'payment-page', params: { uuid: record.uuid } }">
					{{ record.uuid }}
				</router-link>
			</template>
		</template>
	</Table>
</template>

<script>
import { ref, onMounted } from 'vue';
import { TypographyTitle, Table, Badge } from 'ant-design-vue';

import Api from '@/api/Api';
import Utils from '@/api/Utils';

import { useUserStore } from '@/stores/user';

import { getPaymentStatusDisplay } from '@/components/payments/getPaymentStatusDisplay';
import { showErrorMessage } from '@/components/common/errorMessage';

import DatetimeFormatter from '@/components/common/DatetimeFormatter';

import TranslationUtils from '@/i18n/TranslationUtils';


export default {
	components: {
		TypographyTitle, Table, Badge,
		DatetimeFormatter,
	},
	setup() {
		const isLoading = ref(true);
		const userStore = useUserStore();
		const columns = TranslationUtils.addTranslatedField(
			userStore.paymentsTableColumns,
			'dataIndex', 'title',
			'payments.tableColumns',
		);
		const payments = ref([]);

		onMounted(() => {
			Api.paymentGetList(response => {
				isLoading.value = false;
				if (response.status === 'ok') {
					console.log(response.payments);
					payments.value = response.payments.map(payment => ({
						...payment,
						amount: Utils.toRubles(payment.amount),
						statusDisplay: getPaymentStatusDisplay(payment),
					}));
				} else {
					showErrorMessage(response.errors);
				}
			});
		});
		return {
			isLoading,
			columns,
			payments,
		};
	},
}
</script>
